<div class="row p-4">
  <div class="col-sm-12 text-center">
    <i class="far fa-lock accent-icon pb-3" style="color:#ff4c62"></i>
  </div>
  <div class="col-sm-12">
    <h3 class="text-center pb-4 font-weight-bold">Access Denied</h3>
  </div>
  <div class="col-md-12 text-center">
    You do not have access to this content. If you believe you have reached this page in error, please contact your engagement manager.
  </div>
</div>
